export const V2 = 'V2';
export const ABLY = 'ABLY';